<script lang="ts">
  import { BALANCE } from '@2k48/shared';
  import { prefersReducedMotion } from '../../game/motion';

  interface Props {
    tone?: 'cyan' | 'mag' | 'yel';
    count?: number;
    label?: string;
  }

  let { tone = 'cyan', count = 4, label }: Props = $props();

  /**
   * A CSS animation rather than a GSAP timeline. This runs for as long as a
   * queue lasts — potentially the full matchmaking timeout — and a tween on the
   * shared ticker would be paying the render loop for something the compositor
   * can do alone. It is also the one case where "the view unmounted but the
   * tween didn't" cannot happen.
   */
  const step = BALANCE.motion.ui.enterSec;
</script>

<div
  class="pips pips--{tone}"
  class:pips--still={prefersReducedMotion()}
  role={label ? 'status' : 'presentation'}
  aria-label={label}
>
  {#each { length: count } as _, index (index)}
    <i class="pips__pip" style:--pip-delay="{index * step}s"></i>
  {/each}
</div>
